import { useEffect, useRef, useState } from "react";
import styles from "./consultBox.module.scss";
import classNames from "classnames";
import ConsultPopupSuccess from "./ConsultPopupSuccess";
export default function ConsultPopup({ showForm, setShowForm }) {
    const [showSelect, setShowSelect] = useState(false);
    const [showCitySelect, setShowCitySelect] = useState(false);
    const [focusedField, setFocusedField] = useState('');
    const [cities, setCities] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
    const [hoveredChannel, setHoveredChannel] = useState("");
    const [form, setForm] = useState({
        name: "",
        phone: "",
        city: "",
        channel: "",
        description: "",
        agree: false,
    });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const channelRef = useRef(null);
    const cityRef = useRef(null);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                const res = await fetch("https://www.sapo.vn/dms_location.json");
                const data = await res.json();
                setCities(data.cities || []);
            } catch (error) {
                console.error("Lỗi khi tải danh sách tỉnh:", error);
            }
        };
        fetchCities();
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (channelRef.current && !channelRef.current.contains(e.target)) {
                setShowSelect(false);
            }

            if (cityRef.current && !cityRef.current.contains(e.target)) {
                setShowCitySelect(false);
                if (!form.city.trim()) setFocusedField('');
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (showForm) {
            setForm({
                name: "",
                phone: "",
                city: "",
                channel: "",
                description: "",
                agree: false,
            });
            setFocusedField('');
            setShowSelect(false);
            setShowCitySelect(false);
            document.body.classList.add("sapo-modal-open");
        } else {
            document.body.classList.remove("sapo-modal-open");
        }

        return () => {
            document.body.classList.remove("sapo-modal-open");
        };
    }, [showForm]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "phone") {
            const numericValue = value.replace(/\D/g, "");
            setForm({ ...form, phone: numericValue });
            return;
        }
        setForm({ ...form, [name]: type === "checkbox" ? checked : value });

        // 👇 Khi gõ vào ô city, lọc danh sách gợi ý
        if (name === "city") {
            const keyword = value.trim().toLowerCase();
            const filtered = cities.filter(city =>
                city.title.toLowerCase().includes(keyword)
            );
            setFilteredCities(filtered);
            setShowCitySelect(true);
        }
    };

    const handleCitySelect = (city) => {
        setForm({ ...form, city });
        setShowCitySelect(false);
        setFocusedField('');
    };

    const handleChannelSelect = (channel) => {
        setForm({ ...form, channel });
        setShowSelect(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.agree) {
            alert("Vui lòng đồng ý với chính sách trước khi gửi!");
            return;
        }

        try {
            const response = await fetch("/blog/api/register", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
 
            if (!response.ok) {
                alert("Không thể gửi thông tin, vui lòng thử lại sau!");
                return;
            }

            setIsSubmitted(true);
            setForm({ name: "", phone: "", city: "", channel: "", description: "", agree: false });
        } catch (error) {
            console.error("Lỗi gửi form:", error);
            alert("Có lỗi xảy ra, vui lòng thử lại sau!");
        }
    };
    if (isSubmitted) {
        return <ConsultPopupSuccess onClose={() => {
            setIsSubmitted(false);
            setShowForm(false);
        }} />;
    }
    return (
        showForm && (
            <div id={styles["popup-register-article"]}
                className={`sapo-modal register-modal ${showForm ? "show" : ""}`}
                style={{ display: showForm ? "block" : "none" }}
            >
                <div className="sapo-modal-dialog">
                    <div className="sapo-modal-content">
                        <div className={classNames(styles["fix-body"], "sapo-modal-body")}>
                            <button
                                onClick={() => setShowForm(false)}
                                type="button"
                                className={classNames(styles["cursor-pointer"], "btn-close")}
                                aria-label="Close modal"
                            >
                                <span className="mobile">
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.666 10.668L21.3327 21.3346" stroke="#AEAEAE" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M21.3327 10.668L10.666 21.3346L21.3327 10.668Z" fill="#AEAEAE"></path><path d="M21.3327 10.668L10.666 21.3346" stroke="#AEAEAE" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    Đóng
                                </span>
                                <span className="desktop">
                                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 13L1 7L7 1" stroke="#007BFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </span>
                                Quay lại
                            </button>

                            <div className="logo">
                                <img
                                    src={
                                        process.env.NEXT_PUBLIC_BASE_PATH +
                                        "/images/logo/sapo-logo.svg"
                                    }
                                    alt="Sapo logo"
                                />
                            </div>
                            <div className="block-title">
                                <h2>Tư vấn miễn phí</h2>
                                <p>
                                    Hãy cung cấp thông tin của bạn để Sapo tư vấn giải pháp phù
                                    hợp
                                </p>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <ul className="errors"></ul>
                                <div
                                    className={classNames(
                                        "field-wrapper",
                                        { focused: focusedField === "name" },
                                        { "has-value": form.name.trim() }
                                    )}
                                >
                                    <input type="text" pattern="^[ \p{L}\p{M}\d]{2,60}$" maxLength={60} id="FullName" name="name" value={form.name} onChange={handleChange} onFocus={() => setFocusedField('name')} onBlur={() => setFocusedField('')} required />
                                    <label htmlFor="FullName">Họ tên của bạn</label>
                                    <span className="error" data-error="FullName"></span>
                                </div>
                                <div className="form-group">
                                    <div
                                        className={classNames(
                                            "field-wrapper",
                                            { focused: focusedField === "phone" },
                                            { "has-value": form.phone.trim() }
                                        )}
                                    >
                                        <input type="tel" pattern="^0\d{9}$" maxLength={10} id="PhoneNumber" name="phone" value={form.phone} onChange={handleChange} onFocus={() => setFocusedField('phone')} onBlur={() => setFocusedField('')} required />
                                        <label htmlFor="PhoneNumber">Số điện thoại của bạn</label>
                                        <span className="error" data-error="PhoneNumber"></span>
                                    </div>
                                    <div
                                        className={classNames(
                                            "field-wrapper",
                                            "select-city",
                                            { focused: focusedField === "city" },
                                            { "has-value": form.city.trim() }
                                        )}
                                        ref={cityRef}
                                    >
                                        <label htmlFor="CitySelect">Bạn ở tỉnh/thành phố nào?</label>
                                        <input
                                            type="text"
                                            id="CitySelect"
                                            name="city"
                                            value={form.city}
                                            onChange={handleChange}
                                            onFocus={() => {
                                                setFocusedField("city");
                                                setShowCitySelect(true);
                                                setFilteredCities(cities); // show toàn bộ khi click vào
                                            }}
                                            onBlur={() => {
                                                // chỉ bỏ focus nếu không click vào danh sách
                                                setTimeout(() => {
                                                    if (!form.city.trim()) setFocusedField("");
                                                }, 150);
                                            }}
                                        />
                                        <div className="cities-wrapper" style={{ display: showCitySelect ? "block" : "none" }}>
                                            <ul>
                                                {filteredCities.map((item) => (
                                                    <li
                                                        key={item.code}
                                                        className={form.city === item.title ? "active" : ""}
                                                        onClick={() => handleCitySelect(item.title)}
                                                    >
                                                        {item.title}
                                                    </li>
                                                ))}
                                                <li className="no-item" style={{ display: filteredCities.length === 0 ? "block" : "none" }}>Không tìm thấy tỉnh/thành phố</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={classNames(
                                        "field-wrapper",
                                        "select-custom",
                                        { "has-value": form.channel.trim() } // 👈 thêm điều kiện này
                                    )}
                                    ref={channelRef}
                                >
                                    <div
                                        className={`select-dropdown ${showSelect ? 'show' : ''}`}
                                        onClick={() => setShowSelect(!showSelect)}
                                    >
                                        <label htmlFor="PackageTitle" onChange={handleChange}> {form.channel ? form.channel : "Bạn đang kinh doanh trên kênh nào?"}</label>
                                        <ul>
                                            {[
                                                "Quản lý cửa hàng",
                                                "Quản lý bán hàng trên Sàn",
                                                "Quản lý bán hàng trên MXH",
                                                "Quản lý nhà hàng và dịch vụ",
                                                "Thiết kế website bán hàng",
                                                "Quản lý bán hàng hợp kênh",
                                            ].map((item) => (
                                                <li
                                                    key={item}
                                                    className={classNames({
                                                        active: form.channel === item && !hoveredChannel,
                                                    })}
                                                    onMouseEnter={() => setHoveredChannel(item)}
                                                    onMouseLeave={() => setHoveredChannel("")}
                                                    onClick={() => {
                                                        handleChannelSelect(item);
                                                        setHoveredChannel("");
                                                    }}
                                                >
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    className={classNames(
                                        "field-wrapper",
                                        { focused: focusedField === "description" },
                                        { "has-value": form.description.trim() }
                                    )}
                                >
                                    <textarea
                                        cols={20}
                                        id="Description"
                                        name="description"
                                        rows={2}
                                        style={{ height: "70px" }}
                                        value={form.description}
                                        onChange={handleChange}
                                        onFocus={() => setFocusedField('description')}
                                        onBlur={() => setFocusedField('')}
                                        required
                                        className={classNames(styles["style-textarea"])}
                                    ></textarea>
                                    <label htmlFor="Description">
                                        Nội dung muốn trao đổi/ tư vấn
                                    </label>
                                    <span className="error" data-error="Description"></span>
                                </div>
                                <div className="field-wrapper checkbox">
                                    <label htmlFor="ConfirmPolicy">
                                        <input
                                            type="checkbox"
                                            id="ConfirmPolicy"
                                            name="agree"
                                            checked={form.agree}
                                            onChange={handleChange}
                                        />
                                        <span>Tôi đã đọc, đồng ý với <a href="https://help.sapo.vn/chinh-sach-bao-ve-du-lieu-ca-nhan?campaign=form_dungthu_sapo&amp;utm_campaign=form_dungthu_sapo_ref_chinh_sach_bao_mat&amp;utm_source=form_dungthu&amp;utm_medium=textlink_referral" target="_blank">
                                            Chính sách bảo vệ dữ liệu cá nhân</a> &amp; <a href="https://help.sapo.vn/dieu-khoan-va-dieu-kien-su-dung?campaign=form_dungthu_sapo&amp;utm_campaign=form_dungthu_sapo_ref_quy_dinh_su_dung&amp;utm_source=form_dungthu&amp;utm_medium=textlink_referral" target="_blank">
                                                Quy định sử dụng</a> của Sapo
                                        </span>
                                        <span className="error" data-error="ConfirmPolicy"></span>
                                    </label>
                                </div>
                                <div className="actions">
                                    <button disabled={
                                        !(
                                            form.name.trim() &&
                                            form.phone.trim() &&
                                            form.city.trim() &&
                                            form.channel.trim() &&
                                            form.description.trim() &&
                                            form.agree
                                        )
                                    } type="submit" className={classNames(styles["margin-top"], "btn-registration")}>
                                        <span>Yêu cầu tư vấn</span>
                                        <svg viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#FEFDFF"></circle> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4588 13.7441C19.9562 13.2709 19.9323 12.4798 20.4055 11.9772C20.8787 11.4745 21.6698 11.4506 22.1724 11.9238L31.653 20.8488C32.1024 21.0382 32.418 21.4828 32.418 22.0012C32.418 22.5197 32.1023 22.9644 31.6527 23.1537L22.1724 32.0785C21.6698 32.5517 20.8787 32.5278 20.4055 32.0251C19.9323 31.5225 19.9562 30.7314 20.4588 30.2582L27.902 23.2512H12.8336C12.1433 23.2512 11.5836 22.6916 11.5836 22.0012C11.5836 21.3108 12.1433 20.7512 12.8336 20.7512H27.9021L20.4588 13.7441Z" fill="#A6AAAE"></path></svg>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
}

